/* eslint-disable node/no-missing-require */

var Model = require("../types/Model.js");
var xtend = require("xtend");
var Promise = require("promise");
var Permissions =  require("react-native-permissions").default;
var Platform = require("react-native").Platform;

var PERMISSION_TYPES = [
	"camera",
	"microphone",
	"photo",
	"bluetooth",
	"notification",
	"backgroundRefresh",
	"mediaLibrary"
];

module.exports = Model({
	name: "devicepermissions",
	init: init,
	uninit: uninit,
	listeners: listeners,
	triggers: triggers,

	checkPermissions: checkPermissions,
	handle_hide: handle_hide
});

function init() {
	this.push({
		permission: {},
		viewing: PERMISSION_TYPES.reduce(function(result, permission){
			result[permission] = true;
			return result;
		}, {}),
	});
	this.checkPermissions();
}

function listeners() {
	return {
		"focusstate:updated": checkPermissions
	};
}


function triggers() {
	return {
		"hide": handle_hide
	};
}

function checkPermissions(){
	if(Platform.OS === "ios") {
		Promise.all(PERMISSION_TYPES.map(Permissions.check)).then(function(results) {
			this.extend({
				permission: results.reduce(function(permission, status, index){
					var name = PERMISSION_TYPES[index];
					permission[name] = status;
					return permission;
				}, {})
			});
		}.bind(this));
	}
}

function uninit() {
	this.push({});
}

function handle_hide(type){
	var viewing = this.data.viewing;
	var update = {};
	update[type] = false;
	this.extend({
		viewing: xtend(viewing, update)
	});
}
